<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
      Permission List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="modalOpenAddFormList"
            >
              Add Permission
            </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
    
     <template v-slot:[`item.menu`]="{ item }">
       <span v-if="item.menu == 1">✔</span> 
       <span v-else>✖</span>
    </template>
    <template v-slot:[`item.create`]="{ item }">
       <span v-if="item.create == 1">✔</span>
       <span v-else>✖</span>
    </template>
    <template v-slot:[`item.update`]="{ item }">
       <span v-if="item.update == 1">✔</span>
       <span v-else>✖</span>
    </template>
    <template v-slot:[`item.delete`]="{ item }">
       <span v-if="item.delete == 1">✔</span>
       <span v-else>✖</span>
    </template>
    <template v-slot:[`item.requester`]="{ item }">
       <span v-if="item.requester == 1">✔</span>
       <span v-else>✖</span>
    </template>
    <template v-slot:[`item.approver`]="{ item }">
       <span v-if="item.approver == 1">✔</span>
       <span v-else>✖</span>
    </template>
     <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="modalOpenEditFormType(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteConfirmation(item.model_id)"
      >
        mdi-delete
      </v-icon>
    </template>
    
    </v-data-table>
  </v-card>
  <modal style=" z-index: 9999 !important;" ref="modalFormType" class="coba">
      <template v-slot:header>
        <h3>{{ titleFormType }}</h3>
      </template>

      <template v-slot:body>
        <form ref="add_role_permission_form" @submit.prevent="submitFormType">
          <md-card>
            <md-card-header class="md-card-header-icon">
              <div class="card-icon">
                <md-icon>perm_identity</md-icon>
              </div>
              <!-- <h4 class="title">
                        Add Spare Part Master
                      </h4> -->
            </md-card-header>
            <md-card-content>
              <input v-model="id" :readonly="true" type="hidden" />

              <div class="md-layout-item">
                <label class="md-layout-item md-size-15 md-form-label">
                  Model App
                </label>
                <md-field class="md-invalid">
                  <md-select v-model="model_id">
                    <md-option
                      v-for="option in list_model_app_view"
                      :key="option.value"
                      :value="option.id"
                    >
                      {{ option.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item">
                <div class="divChk">
                  <label class="labelChk">Menu</label>
                  <input type="checkbox" class="chk" v-model="form_menu" />
                </div>
                <div class="divChk">
                  <label class="labelChk">Created</label>
                  <input type="checkbox" class="chk" v-model="form_create" />
                </div>
                <!-- <div class="divChk">
                  <label class="labelChk">Edit</label>
                  <input type="checkbox" class="chk" v-model="form_edit" />
                </div> -->
                <div class="divChk">
                  <label class="labelChk">Update</label>
                  <input type="checkbox" class="chk" v-model="form_update" />
                </div>
                <div class="divChk">
                  <label class="labelChk">Delete</label>
                  <input type="checkbox" class="chk" v-model="form_delete" />
                </div>
                <div class="divChk">
                  <label class="labelChk">Requester</label>
                  <input type="checkbox" class="chk" v-model="form_requester" />
                </div>
                <div class="divChk">
                  <label class="labelChk">Approver</label>
                  <input type="checkbox" class="chk" v-model="form_approver" />
                </div>
              </div>
            </md-card-content>

            <md-card-actions>
              <md-button type="submit">
                submit
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </template>

      <template v-slot:footer>
        <md-card-actions>
          <md-button @click="modalCloseFormType">
            Close
          </md-button>
        </md-card-actions>
      </template>
    </modal>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import { Modal } from "@/components";
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {
    Modal,ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        loadTable: true,
        role: "",
        search: '',
        headers: [
          {
            text: 'Model',
            align: 'start fixed',
            value: 'model',
            class: 'fixed',
          },
          { text: 'Menu', value: 'menu', sortable: false, align: 'center' },
          { text: 'Create', value: 'create', sortable: false, align: 'center' },
          { text: 'Update', value: 'update', sortable: false, align: 'center' },
          { text: 'Delete', value: 'delete', sortable: false, align: 'center' },
          { text: 'Requester', value: 'requester', sortable: false, align: 'center' },
          { text: 'Approver', value: 'approver', sortable: false, align: 'center' },
          { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
        ],
        table: [],
         titleFormType: "Add Type",
          id: null,
          model_id: null,
          form_menu: null,
          form_create: null,
          form_update: null,
          form_delete: null,
          form_requester: null,
          form_approver: null,
          list_model_app: null,
          list_model_app_view: null,
      }
    },
    async created() {
      
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
      
      if (this.data_id.data && Object.keys(this.data_id.data).length != 0) {
        this.table = this.data_id.data;
      }
      else{
        this.table = []
      }
      this.loadTable= false
    },
    async modalOpenAddFormList() {
      this.titleFormType = "Add Permission for " + this.data_id.name;
      this.resetForm();
      await this.$store.dispatch("model_app/list");
         this.list_model_app = await this.$store.getters["model_app/list"];
      // if(!this.data_id.division_id || this.data_id.division_id == 1){
      //    await this.$store.dispatch("model_app/list");
      //    this.list_model_app = await this.$store.getters["model_app/list"];
      // }
      // else{
      //   await this.$store.dispatch("model_app/listByDivision",this.data_id.division_id)
      //   this.list_model_app = await this.$store.getters["model_app/model_app"];
      // }     
       this.list_model_app_view = this.list_model_app;
      console.log(this.table.length);
      if (this.table.length != 0) {
        Object.entries(this.table).forEach(([key, value]) => {
          this.list_model_app_view = this.list_model_app_view.filter(
            (data) => data.name != value["model"]
          );
        });
      }
      console.log(this.list_model_app_view);
      this.$refs.modalFormType.openModal();
    },
    async modalOpenEditFormType(item) {
      this.titleFormType = "Edit Permission for " + this.data_id.name;
      console.log(item);
      this.id = item.id;
      this.form_menu = item.menu;
      this.form_create = item.create;
      this.form_update = item.update;
      this.form_delete = item.delete;
      this.model_id = item.model_id;
      this.form_requester = item.requester;
      this.form_approver = item.approver;
      if(!this.data_id.division_id || this.data_id.division_id == 1){
         await this.$store.dispatch("model_app/list");
         this.list_model_app = await this.$store.getters["model_app/list"];
      }
      else{
        await this.$store.dispatch("model_app/listByDivision",this.data_id.division_id)
        this.list_model_app = await this.$store.getters["model_app/model_app"];
      }     

      this.list_model_app_view = this.list_model_app;
      Object.entries(this.table).forEach(([key, value]) => {
        if (value["model_id"] != item.model_id) {
          this.list_model_app_view = this.list_model_app_view.filter(
            (data) => data.name != value["model"]
          );
        }
      });

      this.$refs.modalFormType.openModal();
    },
    modalCloseFormType() {
      this.$refs.modalFormType.closeModal();
    },
    async submitFormType() {
      if(!this.model_id){
        await this.$store.dispatch(
          "alerts/error",
          "Oops, Model empty"
        );
        return
      }
      const data = {
        type: "role_permission",
        model_id: this.model_id,
        id: this.data_id.id,
        menu: this.form_menu,
        edit: this.form_edit,
        update: this.form_update,
        delete: this.form_delete,
        create: this.form_create,
        requester: this.form_requester,
        approver: this.form_approver,
      };

      console.log(this.data_id.id);
      try {
        await this.$store.dispatch("role_permission/add", data);
        if (this.titleFormType == "Add Permission for " + this.data_id.name) {
          await this.$store.dispatch("alerts/success", "Successfully added.");
        } else {
          await this.$store.dispatch("alerts/success", "Successfully changed.");
        }
        this.$refs["add_role_permission_form"].reset();
        this.resetForm();
        this.modalCloseFormType();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      await this.$parent.$parent.getList();

      await this.$parent.$parent.modalCloseList();
      await this.$parent.$parent.viewPermission(this.data_id.id_index, this.data_id.name);
    },
    resetForm() {
      this.id = null;
      this.form_edit = null;
      this.form_create = null;
      this.form_menu = null;
      this.form_update = null;
      this.form_delete = null;
      this.form_requester = null;
      this.form_approver = null;
      this.model_id = null;
    },

    // validasi delete data
    deleteConfirmation(model_id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(model_id);
        }
      });
    },
   
     // fungsi delete
    async deleteData(model_id) {
      try {
        await this.$store.dispatch("role_permission/destroy", {
          id: this.data_id.id,
          model_id: model_id,
        });
        await this.$store.dispatch(
          "alerts/success",
          "Vehicle Type data delete successfully."
        );
        var indexOptionTable = this.table.findIndex(
          (p) => p.model_id == model_id
        );
        this.table.splice(indexOptionTable, 1);
        await this.$parent.$parent.getList();
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }

  .coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>